<div #abaLeitor class="barra-navegacao-container">
  <app-aba-leitor
    class="barra-navegacao-aba-leitor"
    *ngFor="let guia of guias$ | async; index as i"
    [guia]="guia"
    (alternarAba)="alternarPara($event)"
    (fecharAba)="fecharGuia($event)"
    [style.width]="(breakpointLg$ | async) ? '226px' : (larguraAba$ | async)"
    [style.z-index]="120 - i"
    id="{{ 120 - i }}"
  ></app-aba-leitor>
</div>
<app-navegacao-aba-leis
  class="barra-navegacao-aba-leis"
></app-navegacao-aba-leis>
